<style lang='scss'>
@import './assets/sass/main.scss';

// Pagination Style
.paginate-panel {
  display: flex;
  justify-content: flex-end;
}
.paginate-panel ul.paginate-links.drinks {
  display: flex;
  align-items: center;
}
.paginate-panel ul.paginate-links.drinks > li {
  margin: 0 10px;
  cursor: pointer;
}
.paginate-panel ul.paginate-links.drinks > li a {
  color: #000;
}
.paginate-panel ul.paginate-links.drinks > li.disabled a {
  color: gray;
}
.paginate-panel ul.paginate-links.drinks > li.number.active {
  background: #b70033 !important;
  width: 22px !important;
  height: 22px !important;
  text-align: center !important;
  border-radius: 50% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.paginate-panel ul.paginate-links.drinks > li.number.active a {
  color: white !important;
}

.modal-body {
  .modal-close {
    color: #c4383c;
    cursor: pointer;
  }

  .modal-content {
    .list-item:hover {
      color: #c4383c;
    }
  }
}

.v-text-field {
  .v-text-field__slot input {
    margin-bottom: 0;
    border-bottom: none !important;
  }
}

.modal-body {
  border-radius: 10px;
}
</style>
<template lang='pug'>
#app
  v-app
    transition(name='fade', mode='out-in')
      router-view
</template>
<script>
export default {
  name: 'app',
  created() {
    this.$store.dispatch('config/getFees')
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue